import { jsx as _jsx } from "react/jsx-runtime";
import { Link } from 'react-router-dom';
import { useObjectContainerLink } from '../../../ArbitrationObjects/ContainerArbitrator/useObjectContainerLink';
const debug = process.env.REACT_APP_DEBUG && false;
/** @deprecated unnecessary, `DefaultLabelClickWrapper` is implemented better */
export const RoutingLabelClickWrapper = ({ vob, element }) => {
    const { link } = useObjectContainerLink({ vob });
    debug && console.log('RoutingLabelClickWrapper has link', link);
    return (_jsx(Link, { to: link ?? '/', style: { color: 'inherit', textDecoration: 'none', flexGrow: 1 }, children: element }));
};
